import { matchPath, useLocation } from 'react-router-dom';
import routes from '../../routes/Routes';

/** Gets the current route viewed */
export const useCurrentRoute = () => {
  const location = useLocation();
  return routes.find((route) =>
    matchPath(location.pathname, { path: route.path, strict: true, exact: true }),
  );
};
